<template>
  <section class="neighborhood-map">
    <mvtBreadcrumb :geo="breadcrumbGeo" />
    <mvtNewMap
        ref="mapRef"
        :listings="filteredListings"
        :boundaryIndexId="boundary.indexId"
        :inverseBoundary="true"
        :zoomControl="!glb.isMobile"
        gestureHandling="cooperative"
        boundaryTheme="blue"
        class="neighborhood-map__gmap"
    >
      <template #default="slotProps">
        <CustomControl position="TOP_LEFT">
          <div class="p-y-2 p-x-2">
            <mvtWeatherCard
                v-if="weather && Object.keys(weather).length"
                :month="weather.currentMonth"
                :currentTemp="weather.currentMonthMean"
                :lowTemp="weather.currentMonthLow"
                :highTemp="weather.currentMonthHigh"
            />
          </div>
        </CustomControl>
        <CustomControl position="TOP_RIGHT">
          <div class="p-y-2 p-x-2">
            <mvtDropdownList :size="glb.isMobile ? 'small' : 'default'"
               v-model="selectedViewOption"
               textAlign="left"
               :items="viewOptions"
            />
          </div>
        </CustomControl>
      </template>
    </mvtNewMap>
  </section>
</template>

<script src="./neighborhood-map.js">
</script>

<style lang="scss">
  @use "./neighborhood-map.scss" as *;
</style>